<template>
  <div class="auth-form signup-form">
    <div v-if="error" class="error">{{ error.message }}</div>
    <form @submit.prevent="pressed">
      <p class="auth-form__title">Sign Up Here</p>
      <div class="input" :class="{ invalid: $v.email.$error }">
        <label for="email">Mail</label>
        <input
          type="email"
          id="email"
          @blur="$v.email.$touch()"
          v-model="email"
        />
        <p id="pfont" v-if="$v.email.$dirty && !$v.email.email">
          Please provide a valid email address.
        </p>
        <p id="pfont" v-if="$v.email.$dirty && !$v.email.required">
          This field must not be empty.
        </p>
      </div>
      <div class="input" :class="{ invalid: $v.password.$error }">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          @blur="$v.password.$touch()"
          v-model="password"
        />
        <p id="pfont" v-if="$v.password.$error">
          Minimum of 6 characters is required for the password.
        </p>
      </div>
      <div class="input" :class="{ invalid: $v.confirmPassword.$error }">
        <label for="confirmPassword">Confirm Password</label>
        <input
          type="password"
          id="confirmPassword"
          @blur="$v.confirmPassword.$touch()"
          v-model="confirmPassword"
        />
        <p id="pfont" v-if="$v.confirmPassword.$error">
          The password must match the password above.
        </p>
      </div>
      <div class="showpassbtn">
        <h5 id="showbtn">
          <input
            type="checkbox"
            id="showMe"
            class="input-field"
            @click="showPassword"
          /> Show Password
        </h5>
      </div>
      <div class="submit">
        <button type="submit" :disabled="$v.$invalid" class="submitbtn" :class="{ 'submitbtn--disabled': $v.$invalid }">
          Submit
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import { auth } from "../firebase/firebase.utils";

export default {
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      error: "",
    };
  },
  methods: {
    async pressed() {
      try {
        const user = await auth
          .createUserWithEmailAndPassword(this.email, this.password)
          // console.log(val)
          .then(() =>
            swal({
              title: `Welcome ${this.email}!`,
              text: "You've successfully signed up!",
              icon: "success",
              button: "Continue",
            })
          );
        this.$router.replace({ name: "Home" });
      } catch (error) {
        swal({
          title: "Sign up failed!",
          text: "Please, check your internet connection and try again or the email already exists in our records!",
          // icon: "warning",
          button: "OK",
          dangerMode: true,
        });
      }
    },

    showPassword() {
      var Pass = document.getElementById("password");
      var confirmPass = document.getElementById("confirmPassword");
      var showPass = document.getElementById("showMe");
      if (showPass.checked) {
        Pass.setAttribute("type", "text");
      } else {
        Pass.setAttribute("type", "password");
      }

      if (showPass.checked) {
        confirmPassword.setAttribute("type", "text");
      } else {
        confirmPassword.setAttribute("type", "password");
      }
      // showPass.addEventListener("click", showPassword);
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLen: minLength(6),
    },
    confirmPassword: {
      required,
      sameAs: sameAs((vm) => {
        return vm.password;
      }),
    },
  },
};
</script>

<style scoped>
.signup-form .submit button {
  margin-left: 0;
  width: 100%;
  background: var(--color-primary);
  color: #fff;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: var(--radius-sm);
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, opacity 0.2s ease;
}

.signup-form .submit button:hover:not(:disabled) {
  background: var(--color-primary-dark);
  color: #fff;
}

.signup-form .submit button:disabled,
.signup-form .submit button.submitbtn--disabled {
  background: #cbd5e1;
  color: #94a3b8;
  cursor: not-allowed;
  opacity: 1;
}

.signup-form #pfont {
  font-size: 0.85rem;
  color: #dc2626;
  margin: 0.25rem 0 0;
}

.signup-form .input.invalid input {
  border-color: #ef4444;
  background: #fef2f2;
}

.signup-form .input.invalid label {
  color: #dc2626;
}
</style>
